import { LuSearch, LuChevronDown } from "@/Components/Icons/Icons.jsx";

export default {
  row1: [
    {
      column: "column1",
      rows: {
        row1: [
          {
            name: "eSanchitDocumentLevel", label: "Document Level", component: "dropdown", endIconName: LuChevronDown,
            options: [
              { label: "Job", value: "Job" },
              { label: "Invoice", value: "Invoice" },
              { label: "Item", value: "Item" },

            ]
          },
          {
            name: "eSanchitInvsrNo", label: "Inv.Sr.No", component: "text-field", type: "autocomplete",
            endpoint: "getInvoiceMaster",
            dependsOn: "eSanchitDocumentLevel",
            dependsValue: ["Invoice", "Item"]

          },
          {
            name: "eSanchitItemSrNo", label: "Item.Sr.No", component: "text-field",
            type: "autocomplete",
            endpoint: "getDescription",
            dependsOn: "eSanchitDocumentLevel",
            dependsValue: ["Item"]
          },
        ],
        row2: [
          {
            name: "eSanchitScope", label: "Scope", component: "dropdown", width: "32%",
            options: [
              { label: "This Job Only", value: "This Job Only" },
              { label: "Multiple Jobs", value: "Multiple Jobs" },

            ]
          },
        ],
        row3: [
          { name: "eSanchitIRN", label: "IRN(Image Ref.No.)", component: "text-field", width: "50%" },
          {
            name: "eSanchitDocumentType", label: "Document Type", component: "dropdown", endIconName: LuChevronDown, width: "50%",
            options: [

              { label: "101AA1 - AADHAAR ID-UID", value: "101AA1" },
              { label: "740000 - Air waybill", value: "740000" },
              { label: "911DA2 - Airoperator Permit (Non-Scheduled)", value: "911DA2" },
              { label: "102SB1 - Analytical Report", value: "102SB1" },
              { label: "811GJ1 - Approval for participation in overseas exhibition", value: "811GJ1" },
              { label: "830A21 - Assessment Copy SB", value: "830A21" },
              { label: "955000 - ATA carnet", value: "955000" },
              { label: "HAC001 - Authorisation Letter", value: "HAC001" },
              { label: "046L01 - Bank Letter or Certificate", value: "046L01" },
              { label: "430000 - Banker's guarantee", value: "430000" },
              { label: "0030DC - Batch Release Certificate", value: "0030DC" },
              { label: "705000 - Bill of lading", value: "705000" },
              { label: "001003 - Blood Analysis Report", value: "001003" },
              { label: "165000 - Bond", value: "165000" },
              { label: "626WC3 - Captive Bred/ artificially propogated Certificate", value: "626WC3" },
              { label: "861CT1 - Certificate of Origin (Non Preferencial) Issued By TEXPROCIL", value: "861CT1" },
              { label: "911TB1 - CC for Tea Import by TB", value: "911TB1" },
              { label: "911BN4 - Certificate of official approval for import of opium, etc under Rule 54 of NDPS Rules 1985", value: "911BN4" },
              { label: "101SB1 - Certificate of Registration of Export of Spices", value: "101SB1" },
              { label: "091EI2 - Certificate for Export (Egg Products)", value: "091EI2" },
              { label: "636EI2 - Certificate for Export (Honey)", value: "636EI2" },
              { label: "093EI1 - Certificate for Export (Animals casings)", value: "093EI1" },
              { label: "811EI1 - Certificate for Export (Feed additives and mixtures)", value: "811EI1" },
              { label: "852EI1 - Certificate for Export (Fish & Fishery Products)", value: "852EI1" },
              { label: "636EI1 - Certificate for Export (Milk products)", value: "636EI1" },
              { label: "091EI1 - Certificate for Export (Poultrymeat and poultry meat products)", value: "091EI1" },
              { label: "911LE2 - Certificate for Import clearance of textiles and textiles articles", value: "911LE2" },
              { label: "00100D - Certificate of analysis", value: "00100D" },
              { label: "0010DC - Certificate of analysis - Drug", value: "0010DC" },
              { label: "0010FS - Certificate of Analysis - Food & Supplement", value: "0010FS" },
              { label: "002TO1 - Certificate of Authenticity - Tobacco", value: "002TO1" },
              { label: "648000 - Certificate of compliance with standards of the World Organization for Animal Health (OIE)", value: "648000" },
              { label: "002000 - Certificate of conformity", value: "002000" },
              { label: "811AP1 - Certificate of Export for Peanut and Peanut Products", value: "811AP1" },
              { label: "852EI2 - Certificate of Inspection (Dried Fish & Fish Maws)", value: "852EI2" },
              { label: "861000 - Certificate of origin", value: "861000" },
              { label: "B64TO1 - Certificate of Origin in Form-A under GSP", value: "B64TO1" },
              { label: "861016 - Certificate of origin (Indo Mauritius CECPA)", value: "861016" },
              { label: "861CA1 - Certificate of Origin (Non Preferential)", value: "861CA1" },
              { label: "861EC1 - Certificate of Origin (Non Preferential) Issued by Electronic & Computer Software Export Promotion", value: "861EC1" },
              { label: "861PP1 - Certificate of Origin (Non Preferential) Issued by Plastic Export Promotion Council", value: "861PP1" },
              { label: "861SR1 - Certificate of Origin (Non Preferential) Issued by Synthetic & Rayon Textile Export Council", value: "861SR1" },
              { label: "861CB1 - Certificate of Origin (Non Preferential)", value: "861CB1" },
              { label: "861AE1 - Certificate of Origin (Non Preferential)", value: "861AE1" },
              { label: "861E1 - Certificate of Origin (Non Preferential)", value: "861E1" },
              { label: "861CH1 - Certificate of Origin (Non Preferential)", value: "861CH1" },
              { label: "861CL1 - Certificate of Origin (Non Preferential)", value: "861CL1" },
              { label: "861SF1 - Certificate of Origin (Non Preferential) Issued by SHEFEXCIL", value: "861SF1" },
              { label: "865000 - Certificate of origin form GSP", value: "865000" },
              { label: "864TO3 - Certificate of Origin under APTA", value: "864TO3" },
              { label: "864TO4 - Certificate of Origin under SAPTA", value: "864TO4" },
              { label: "003000 - Certificate of quality", value: "003000" },
              { label: "101IR1 - Certificate of Registration", value: "101IR1" },
              { label: "101RN1 - Certificate of Registration", value: "101RN1" },
              { label: "101MP1 - Certificate of Registration as Exporter", value: "101MP1" },
              { label: "101IC3 - Certificate of Registration for Import", value: "101IC3" },
              { label: "101IC4 - Certificate of Registration for Import for Export Only", value: "101IC4" },
              { label: "101IC2 - Certificate of Registration for Indigenous Manufacturer", value: "101IC2" },
              { label: "101IC1 - Certificate of Registration for Indigenous Manufacturer for export only", value: "101IC1" },

              { label: "101LM1 - Certificate of Registration of Importer of Weights and Measures", value: "101LM1" },
              { label: "798000 - Certificate of registry", value: "798000" },
              { label: "6490DC - Certified copy of the licensed premises", value: "6490DC" },
              { label: "6261WC - CITES Certificate", value: "6261WC" },
              { label: "626WC2 - CITES Comparable Document for Dalbergia sissoo", value: "626WC2" },
              { label: "811EP2 - Classification Certificate", value: "811EP2" },
              { label: "380000 - Commercial Invoice", value: "380000" },
              { label: "331000 - Commercial invoice which includes a packing list", value: "331000" },
              { label: "911ME2 - Concessional Customs Duty Certificate for import of raw materials issued by MEITY", value: "911ME2" },
              { label: "911MN3 - Concessional Custom Duty Certificate for Municipal Corporation - Urban and Industrial Waste", value: "911MN3" },
              { label: "911MN1 - Concessional Custom Duty Certificate for Solar project issued by MNRE", value: "911MN1" },
              { label: "911MN2 - Concessional Custom Duty Certificate for Wind farm Project issued by MNRE", value: "911MN2" },
              { label: "911ME1 - Concessional Customs Duty Certificate (CCDC) for import of mould, tools or dies issued by MEITY", value: "911ME1" },
              { label: "911ME3 - Concessional Excise Duty Certificate issued by MEITY", value: "911ME3" },
              { label: "6490HZ - Consent to Operate / Registration", value: "6490HZ" },
              { label: "870000 - Consular invoice", value: "870000" },
              { label: "788000 - Container manifest (unit packing list)", value: "788000" },
              { label: "7880FS - Container Stuffing Report", value: "7880FS" },
              { label: "315000 - Contract", value: "315000" },
              { label: "1495L1 - Contract MOU Agreement With Foreign Shipping Lines", value: "1495L1" },

              //5

              { label: "101LM1 - Certificate of Registration of Importer of Weights and Measures", value: "101LM1" },
              { label: "798000 - Certificate of registry", value: "798000" },
              { label: "6490DC - Certified copy of the licensed premises", value: "6490DC" },
              { label: "6261WC - CITES Certificate", value: "6261WC" },
              { label: "626WC2 - CITES Comparable Document for Dalbergia sissoo", value: "626WC2" },
              { label: "811EP2 - Classification Certificate", value: "811EP2" },
              { label: "380000 - Commercial Invoice", value: "380000" },
              { label: "331000 - Commercial invoice which includes a packing list", value: "331000" },
              { label: "911ME2 - Concessional Customs Duty Certificate for import of raw materials issued by MEITY", value: "911ME2" },
              { label: "911MN3 - Concessional Custom Duty Certificate for Municipal Corporation - Urban and Industrial Waste", value: "911MN3" },
              { label: "911MN1 - Concessional Custom Duty Certificate for Solar project issued by MNRE", value: "911MN1" },
              { label: "911MN2 - Concessional Custom Duty Certificate for Wind farm Project issued by MNRE", value: "911MN2" },
              { label: "911ME1 - Concessional Customs Duty Certificate (CCDC) for import of mould, tools or dies issued by MEITY", value: "911ME1" },
              { label: "911ME3 - Concessional Excise Duty Certificate issued by MEITY", value: "911ME3" },
              { label: "6490HZ - Consent to Operate / Registration", value: "6490HZ" },
              { label: "870000 - Consular invoice", value: "870000" },
              { label: "788000 - Container manifest (unit packing list)", value: "788000" },
              { label: "7880FS - Container Stuffing Report", value: "7880FS" },
              { label: "315000 - Contract", value: "315000" },
              { label: "1495L1 - Contract MOU Agreement With Foreign Shipping Lines", value: "1495L1" },



            ],
            required: true

          },
        ],
        row4: [
          {
            name: "eSanchitIcegateId", label: "ICEGATE ID", component: "dropdown", endIconName: LuChevronDown, width: "50%",
            options: [
              { label: "AAGCR9244LPSU00 - FCard - admin", value: "AAGCR9244LPSU00" },
              { label: "AAHCA3430APSU00 - FCard - Avalon", value: "AAHCA3430APSU00" },
              { label: "AAPCS7948KPSU00 - FCard - admin", value: "AAPCS7948KPSU00" },
              { label: "AAPCS7948KPSU02 - FCard - admin", value: "AAPCS7948KPSU02" },
              { label: "ARUNKUMBHARE1973 - GCard - ARUNKUMBHARE1973", value: "ARUNKUMBHARE1973" },
              { label: "BLRTRIPATHI - FCard - BLRTRIPATHI", value: "BLRTRIPATHI" },
              { label: "BOMTRIPATH - FCard - BOMTRIPATH", value: "BOMTRIPATH" },
              { label: "DELTRIPATH - FCard - DELTRIPATH", value: "DELTRIPATH" },
              { label: "HPPPSEZZAIR - FCard - HPPPSEZZAIR", value: "HPPPSEZZAIR" },
              { label: "HPPPSEZCHA - FCard - HPPPSEZCHA", value: "HPPPSEZCHA" },
              { label: "SANDESHGORULE1987 - GCard - SANDESHGORULE1987", value: "SANDESHGORULE1987" },
              { label: "TRIPATHAMD - GCard - TRIPATHAMD", value: "TRIPATHAMD" },
              { label: "TRIPATHBLR - FCard - TRIPATHBLR", value: "TRIPATHBLR" },
              { label: "TRIPATHBLR1 - GCard - TRIPATHBLR1", value: "TRIPATHBLR1" },
              { label: "TRIPATHBLR2 - FCard - TRIPATHBLR2", value: "TRIPATHBLR2" },
              { label: "TRIPATHCCU123 - GCard - TRIPATHCCU123", value: "TRIPATHCCU123" },
              { label: "TRIPATHHYD - FCard - TRIPATHHYD", value: "TRIPATHHYD" },
              { label: "TRIPATHMAA - FCard - TRIPATHMAA", value: "TRIPATHMAA" },
              { label: "Other", value: "Other" },

            ],
            required: true

          },
          { name: "eSanchitOtherIcegateId", label: "OTHER ICEGATE ID", component: "text-field", width: "50%", required: true },
        ],
        row5: [
          { name: "eSanchitICegateFileName", label: "ICEGATE Filename", component: "text-field", width: "50%" },
          { name: "eSanchitFileType", label: "File Type", component: "text-field", width: "50%" },
        ],
        row6: [
          { name: "eSanchitDatetimeupload", label: "Date-Time of Upload", component: "datetimeselector", width: "50%" },
        ],
        row7: [
          { name: "eSanchitDocumentRefNo", label: "Document Reference No", component: "text-field", width: "50%" },
          { name: "eSanchitPlaceofIssue", label: "Place of Issue", component: "text-field", width: "50%", required: true },
        ],
        row8: [
          { name: "eSanchitDateofIssue", label: "Date of Issue", component: "dateselector", width: "50%", required: true },
          { name: "eSanchitExpiryDate", label: "Expiry Date", component: "dateselector", width: "50%" },
        ],
        row9: [
          { name: "Issuing Party Details", component: "header", label: "Issuing Party Details" },
          { name: "Beneficiary Party Details", component: "header", label: "Beneficiary Party Details" },
        ],
        row10: [
          {
            name: "eSanchitIssuingName", label: "Name", component: "text-field", width: "50%", icon: LuSearch,
            type: "autocomplete",
            endpoint: "getCustomers",
            autofillTargets: {
              "eSanchitIssuingAddressLine1": "addressLine",
              "eSanchitIssuingCityName": "city",
              "issuingCustomerPostalCode": "pincode",

            },
            endPointWithId : "getCustomersAddress"
          },

          {
            name: "eSanchitbeneficiaryName", label: "Name", component: "text-field", width: "50%", icon: LuSearch,
            endpoint: "getCustomers", type: "autocomplete",
            autofillTargets: {
              "eSanchitbeneficiaryAddressLine1": "addressLine",
              "eSanchitbeneficiaryCityName": "city",
              "beneficiaryCustomerPostalCode": "pincode",
            },
           endPointWithId : "getCustomersAddress"
          },
        ],
        row11: [
          { name: "eSanchitIssuingcode", label: "Code", component: "text-field", width: "50%" },
          { name: "eSanchitbeneficiarycode", label: "Code", component: "text-field", width: "50%" },
        ],
        row12: [
          { name: "eSanchitIssuingAddressLine1", label: "Address Line.1", component: "text-field", width: "50%" },
          { name: "eSanchitbeneficiaryAddressLine1", label: "Address Line.1", component: "text-field", width: "50%" },
        ],
        row13: [
          { name: "eSanchitIssuingAddressLine2", label: "Address Line.2", component: "text-field", width: "50%" },
          { name: "eSanchitbeneficiaryAddressLine2", label: "Address Line.2", component: "text-field", width: "50%" },
        ],
        row14: [
          {
            name: "eSanchitIssuingCityName", label: "City", component: "text-field", width: "50%", type: "autocomplete",
            endpoint: "getCityMaster",

          },
          {
            name: "eSanchitbeneficiaryCityName", label: "City", component: "text-field", width: "50%", type: "autocomplete",
            endpoint: "getCityMaster",
          },
        ],
        row15: [
          { name: "eSanchitIssuingpincode", label: "Pin Code", component: "text-field", width: "50%" },
          { name: "eSanchitbeneficiarypincode", label: "Pin Code", component: "text-field", width: "50%" },
        ],
        row16: [
          { name: "eSanchitAttachmentId", label: "Unsigned Document PDF", component: "fileselector", width: "50%", allowedFileTypes: "PDF" },
          { name: "unsignedPdfAction", label: "Action", component: "outlinebutton", width: "20%", sx: { mt: "33px" } },
        ],
      },
    },
  ]
};




